import { VStack, Text } from '@genial/components';
import React from 'react';

import { SelectableTagOption, SelectableTags } from '../../../SelectableTags';

export declare namespace TagsTypes {
  type SelectionProps = string[];

  type SelectionChange = (
    selections: SelectionProps,
    fieldName: string,
    filterIndex: number
  ) => void;

  interface Props {
    type: 'tags';
    fieldName: string;
    filterIndex: number;
    title: string;
    options: SelectableTagOption[];
    onSelectionChange: SelectionChange;
    selection?: SelectionProps;
    onlyOneSelection?: boolean;
    hidden?: boolean;
  }
}

export const hasTagsSelection = (selection: string[]) => !!selection.length;

export const Tags: React.FC<TagsTypes.Props> = ({
  title,
  options,
  fieldName,
  filterIndex,
  onSelectionChange,
  selection,
  onlyOneSelection = false,
  hidden = false,
}) => {
  const [selections, setSelections] = React.useState<string[]>(selection || []);

  React.useEffect(() => {
    setSelections(selection || []);
  }, [selection]);

  const handleChange = (value: string, selected: boolean) => {
    const next = onlyOneSelection ? [] : [...selections];
    if (selected) {
      next.push(value);
    } else {
      const index = next.indexOf(value);
      if (index >= 0) {
        next.splice(index, 1);
      }
    }
    setSelections(next);
    onSelectionChange(next, fieldName, filterIndex);
  };

  if (!options.length || hidden) {
    return null;
  }

  return (
    <VStack space="inline.xxxs">
      <Text variant="semibold" fontSize="md" lineHeight="distant">
        {title}
      </Text>
      <SelectableTags
        options={options}
        selectedValues={selections}
        onChange={handleChange}
        testIDPrefix={`filter-tag-${fieldName}`}
      />
    </VStack>
  );
};
